import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-header',
	templateUrl:'./WaHeaderPluginCompPage.html',
	styles: [],
	styleUrls:['./WaHeaderPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaHeaderPluginCompPage
{
	mdContent_1136 = `\`\`\`java
import com.jwebmp.webawesomepro.WaHeader;
\`\`\``;
	mdContent_1137 = `\`\`\`java
new WaHeader&lt;&gt;()
\`\`\``;
}
